import { render, staticRenderFns } from "./BiaotiBianji.vue?vue&type=template&id=2e8c4c31&"
import script from "./BiaotiBianji.vue?vue&type=script&lang=js&"
export * from "./BiaotiBianji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BiaotiBianji.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports